import React, { isValidElement } from 'react';

const TableCol = ({ width, children }) => {
  const style = {
    flex: width ? undefined : 1,
    minWidth: 0
  };

  return (
    <div className='table-col' style={style}>
      {isValidElement(children) ? (
        children
      ) : (
        <span
          className='table-col__text'
          title={children}
        >
          {children}
        </span>
      )}
    </div>
  )
}

export default TableCol;
